import { PortfolioGetCentralCancellationPolicyOverviewEntries } from '@mews-commander/data-access';
import { Table } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useCentralCancellationPolicyOverviewEntries } from '../../queries';
import { CreateCancellationPolicyButton } from './CreateCancellationPolicyButton';

interface Props {
    tableState: PortfolioGetCentralCancellationPolicyOverviewEntries;
}
export const CancellationPolicyTableContent = ({ tableState }: Props) => {
    const { data, isFetching } = useCentralCancellationPolicyOverviewEntries(tableState);
    return (
        <Table
            uniqueRowId="id"
            data={data.data || []}
            amountOfRows={data.totalRowCount}
            loading={isFetching}
            fixedFirstColumn
            emptyState={{
                primaryText: lt('CancellationPolicyTableEmptyStatePrimaryText'),
                secondaryText: lt('CancellationPolicyTableEmptyStateSecondaryText'),
                action: <CreateCancellationPolicyButton size="small" />,
            }}
        />
    );
};
